import React from "react"
import styled from "styled-components"
import Logo from "./Logo"
import * as Theme from "../libs/theme"
import { Link } from "react-scroll"

const Header: React.FC = () => {
	const nav = [
		{
			title: "Features",
			href: "features",
		},
		{
			title: "Pricing",
			href: "pricing",
		},
	]
	return (
		<HeaderWrapper>
			<Logo responsive size={40} textColor="#000" target="_self" />
			<NavWrapper>
				{nav.map((item) => (
					<Link to={item.href} offset={-110} smooth={true} key={item.title}>
						<Nav>{item.title}</Nav>
					</Link>
				))}
				<a href="mailto:support@busstock.app">
					<Nav>Support</Nav>
				</a>
			</NavWrapper>
			<a href="https://dashboard.busstock.app/login">
				<Nav>Log in</Nav>
			</a>
			<a href="https://dashboard.busstock.app/">
				<SignUpButton>Start Now</SignUpButton>
			</a>
		</HeaderWrapper>
	)
}
const HeaderWrapper = styled.div`
	height: 90px;
	padding: 20px;
	display: flex;
	background-color: white;
	align-items: center;
	box-shadow: rgba(0, 0, 0, 0.15) 0px 0px 40px;
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	z-index: 5000;
	@media only screen and (max-width: 767px) {
		top: auto;
		bottom: 0;
		padding: 10px;
	}
`
const NavWrapper = styled.nav`
	margin-left: 20px;
	display: flex;
	flex: 1;
	@media only screen and (max-width: 767px) {
		margin-left: 0px;
	}
`
const Nav = styled.span`
	margin: 0 20px;
	color: ${Theme.Colors.Primary};
	font-weight: bold;
	cursor: pointer;
	:hover {
		color: ${Theme.Colors.PrimaryHover};
	}
	@media only screen and (max-width: 1023px) {
		margin: 0 10px;
	}
	@media only screen and (max-width: 767px) {
		margin: 0 5px;
		font-size: 14px;
	}
	@media only screen and (max-width: 410px) {
		margin: 0 5px;
		font-size: 12px;
	}
`
const SignUpButton = styled(Nav)`
	color: #fff;
	margin-right: 0;
	padding: 10px 12px;
	background-color: ${Theme.Colors.Primary};
	border-radius: 5px;
	:hover {
		color: #fff;
		background-color: ${Theme.Colors.PrimaryHover};
	}
`

export default Header
